import {Component} from '@angular/core';
import {environment} from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent{
  title = 'ui';
  siteVersion = '';
  // @ts-ignore
  isClicked = false;
  headlineIndices: any;
  EMIXIndices: any;
  s3ContentsLoaded = false;
  currentYear = new Date().getFullYear();
  downloadPage = true;
  isUCITS = false;
  healthCheck = false;
  constructor() {
    this.siteVersion = environment.version;
    this.downloadPage = window.location.href.includes('Download');
    this.isUCITS = window.location.href.includes('UCITS');
    this.healthCheck = window.location.href.includes('health');
  }

  getHeadlineIndices(event: any): void{
    this.headlineIndices = event;
  }

  getEMIXIndices(event: any): void{
    this.EMIXIndices = event;
  }

  hasS3ContentsLoaded(event: any): void{
    this.s3ContentsLoaded = event;
  }

  clickedOutside(): void{
    this.isClicked = !this.isClicked;
  }

}
